import { render, staticRenderFns } from "./LookAndFeel.vue?vue&type=template&id=3b0cc185"
import script from "./LookAndFeel.vue?vue&type=script&lang=ts"
export * from "./LookAndFeel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports